import React, { useState, useCallback } from 'react'
import { Main } from './ModalTabs'
import Modal from '../../components/Modal'
import Confirmation from '../../components/Confirmation/Confirmation'

export default function ModalComponent({ data, closeModal, search, list }) {
  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  return (
    <Modal open={!!data} onClose={handleClose} closeOnOverlayClick={true} closeOnEsc={true}>
      <Main closeModal={closeModal} data={data} addMode={!data?.lid} search={search} list={list} />
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
